import { z } from 'zod';

export const ConversationFactsSchema = z.object({
  topicsDiscussed: z
    .array(z.string())
    .optional()
    .describe(
      'A list of key topics discussed during the conversation, such as pricing, procedures, or scheduling.',
    ),

  importantDetails: z
    .array(z.string())
    .optional()
    .describe(
      "Important details mentioned, such as dates, specific requests, or personal information. For each detail, provide a topic and a brief description of the detail if necessary. By instance, instead of providing just the DOB, it should be: 'Date Of Birth: ...'",
    ),

  conversationPurpose: z
    .string()
    .optional()
    .describe(
      'A brief description summarizing the overall purpose or intent of the conversation.',
    ),

  requestsByContact: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'Explicit requests made by the contact, such as asking for availability or pricing.',
    ),

  concernsByContact: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'Any concerns raised by the contact, whether explicit or inferred.',
    ),

  questionsByContact: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'Specific questions asked by the contact during the conversation.',
    ),

  cosmeticProcedures: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'A list of cosmetic procedures mentioned during the conversation, such as Brazilian Butt Lift or Rhinoplasty. This should always be in English.',
    ),

  doctorNames: z
    .string()
    .optional()
    .nullable()
    .describe(
      'A string summarizing the names of doctors mentioned during the conversation.',
    ),

  doctorsMentionedByContact: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'A list of names of doctors specifically mentioned by the contact.',
    ),

  doctorsMentionedByRep: z
    .array(z.string())
    .optional()
    .nullable()
    .describe(
      'A list of names of doctors specifically mentioned by the Sales Representative.',
    ),
});

export type ConversationFactsDto = z.infer<typeof ConversationFactsSchema>;
